<template>
  <div class="wifi-error">
    <div class="error-content">
      <img src="./no-wifi.svg" alt="No WiFi" class="wifi-icon" />
      <h3>Connexion impossible</h3>
      <p>Vérifiez votre connexion internet et réessayez.</p>
      <button @click="retry" class="retry-button">
        Réessayer
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WifiError',
  methods: {
    retry() {
      // Recharger la page ou émettre un événement
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './WifiError.scss';
</style>
